import React from 'react';
import { Row, Col } from 'components/ui/grid';
import { Button, Section, Logo, Card, CardBody } from 'components/ui';
import { useI18n } from 'hooks/use_i18n';
import { DEFAULT_CONTACT_EMAIL, PROTOCOL, APP_DOMAIN } from 'constants';

const ApplicationPageNotFound = () => {
  const { t } = useI18n();
  return (
    <Section className="py-0" data-cy="insurgate_application">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
          <p className="text-center">
            <Logo as="a" href="/" width="30%" />
          </p>
          <Card className="text-center" data-cy="404">
            <CardBody className="p-5">
              <div className="display-1 text-200 fs-error">404</div>
              <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
                {t('apps.main.page_not_found.title')}
              </p>
              <hr />
              <p>
                {t('apps.main.page_not_found.description')}
                <a href={`mailto:${DEFAULT_CONTACT_EMAIL}`} className="ml-1">
                  {t('apps.main.page_not_found.contact_us')}
                </a>
              </p>
              <Button
                href={`${PROTOCOL}://${APP_DOMAIN}`}
                as="a"
                color="default"
              >
                {t('apps.main.page_not_found.back_button')}
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default ApplicationPageNotFound;
